import axios from './main'
import routes from './routes'
import reqOption from '../utils/reqOption'

export const register = async (username, email, password) => {
  try {
    const { data } = await axios.post(routes.register(), {
      username,
      email,
      password,
    })
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}
export const changePassword = async (old_password, new_password) => {
  try {
    const { data } = await axios.post(routes.changePassword(), {
      old_password,
      new_password,
    })
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}
export const login = async (username, password) => {
  try {
    const { data } = await axios.post(routes.login(), {
      username,
      password,
    })
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}
export const sendResetCode = async (email) => {
  try {
    const { data } = await axios.post(routes.sendResetCode(), {
      email,
    })
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}
export const verifyCode = async (email, code, new_password) => {
  try {
    const { data } = await axios.post(routes.verifyCode(), {
      email,
      code,
      new_password,
    })
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}
export const createApiKey = async (title) => {
  try {
    const { data } = await axios.post(routes.createApiKey(), {
      title,
    })
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}
export const deleteApiKey = async (id) => {
  try {
    const { data } = await axios.delete(routes.deleteApiKey(id))
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}
export const getApiKeys = async () => {
  try {
    const { data } = await axios.get(routes.getApiKeys())
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}
export const getUserProfile = async () => {
  try {
    const { data } = await axios.get(routes.getUserProfile())
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}
export const updateUserProfile = async (firstname, lastname, phone, nationalId) => {
  try {
    const { data } = await axios.patch(routes.updateUserProfile(), {
      firstname,
      lastname,
      phone,
      nationalId,
    })
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}
